module.exports = __webpack_public_path__ + "static/img/softys-movil.319a618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/softys-movil.png
// module id = 3wqG
// module chunks = 28